



















































































































































import Vue, { PropType } from 'vue'
import Card from '@/components/Card.vue'
import DataIterator from '@/components/DataIterator.vue'
import {
  getMessengers,
  getWholesalers,
} from '@/api/Remittances/remittances.api'
import UserCard from '@/components/UserCard.vue'
import DetailsDialog from '../Messengers/DetailsDialog.vue'
import WholesalerDialog from '../Wholesaler/WholesalerDialog.vue'
import ActionButton from '@/components/ActionButton.vue'
import { Messenger, VueTable, Params } from '@/utils/interfaces'
import { Remittance, Wholesaler } from '@/utils/interfaces/remittance.interface'
import Dialog from '@/components/Dialog.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { debounce } from 'debounce'
import { number } from '@/utils/validators'

export default Vue.extend({
  components: {
    appDialog: Dialog,
    appCard: Card,
    appDataIterator: DataIterator,
    appUserCard: UserCard,
    appMessengerDialog: DetailsDialog,
    appWholesalerDialog: WholesalerDialog,
    appActionButton: ActionButton,
    appConfirmDialog: ConfirmDialog,
  },
  props: {
    remittance: Object as PropType<Remittance>,
  },
  data: function() {
    return {
      tabs: 0,
      rules: {
        number: (v: string | number) =>
          number(Number(v).toString()) ||
          this.$t('validation.must-be-a-number'),
        positive: (v: number) =>
          v >= 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
        required: (v: string | number) =>
          !!v || v === 0 || this.$t('validation.field-required'),
      },
      getMessengers: (params?: Params) =>
        getMessengers({
          messenger_configs__subregion_commissions__subregion__region: this
            .remittance.region,
          messenger_configs__delivery_currency: this.remittance
            .delivery_currency,
          ...params,
          messenger_configs__is_active: true,
          role: 'AGENT',
          is_active: true,
        }),
      getWholesalers: getWholesalers,
      fields: ['username', 'first_name', 'last_name', 'phone', 'email'],
      detailsItem: {} as Messenger | Wholesaler,
      assignItem: {} as Messenger | Wholesaler,
      confirmDialog: false,
      messengerDialog: false,
      wholesalerDialog: false,
      loading: false,
      search: '',
      tabsNumber: 3,
      custom: false,
      custom_commission: null,
      description: '',
      loadingConfirm: false,
    }
  },
  computed: {
    table(): VueTable {
      const tables = this.$refs.table as VueTable[]
      if (this.$refs.table) {
        return tables[this.tabs]
      } else return {} as VueTable
    },
    getter(): (params?: Params) => Promise<any> {
      if (this.tabs === 0) {
        return (params?: Params) =>
          getMessengers({
            messenger_configs__subregion_commissions__subregion: this.remittance
              .subregion,
            ...params,
            role: 'AGENT',
          })
      } else if (this.tabs === 1) {
        return (params?: Params) =>
          getMessengers({
            ...params,
            role: 'AGENT',
          })
      } else {
        return getWholesalers
      }
    },
  },
  methods: {
    onDetails(item: Messenger | Wholesaler) {
      this.detailsItem = item
      if (item.role === 'WHOLESALER') {
        this.wholesalerDialog = true
      } else {
        this.messengerDialog = true
      }
    },
    onAssign(item: Messenger | Wholesaler) {
      this.confirmDialog = true
      this.assignItem = item
    },
    onDone(value: boolean) {
      if (value) {
        const custom_commission =
          !this.custom_commission && this.custom_commission !== 0
            ? undefined
            : this.custom_commission
        this.$emit('new-assignment', {
          custom_commission,
          user: this.assignItem,
          description: this.description,
        })
        this.description = ''
        this.$emit('input', false)
      }
    },
    onInput(search: string) {
      this.loading = true
      this.deb(this, search)
    },
    deb: debounce(
      (vm: Vue & { table: VueTable; loading: boolean }, search: string) => {
        vm.table.newFilter({ search })
        vm.loading = false
      },
      1000,
    ),
  },
  created() {
    if (this.$store.getters.profile.role === 'AGENT') {
      this.tabsNumber = 2
    }
  },
  watch: {
    custom(value) {
      if (!value) {
        this.custom_commission = null
      }
    },
  },
})
